import { BulkUpdateProgressBanner } from "#src/batteries-included-components/Banners/BulkUpdateProgressBanner/BulkUpdateProgressBanner";
import { ESTIMATION_METHODS_QUERY_KEY } from "#src/components/hooks/adapters/useEstimationMethods";
import { useStorageKey } from "#src/hooks/useStorageKey";
import { useQueryClient } from "@tanstack/react-query";
import { AssetStatus } from "@validereinc/domain";
import React from "react";
import { useParams } from "react-router";

export const DeviceUpdateStatusBanner = () => {
  const { deviceId } = useParams<{ deviceId: string }>();
  const [updateDeviceStatusJobStorageKey] = useStorageKey(
    ["async-job"],
    `update-device-status-${deviceId}`
  );
  const queryClient = useQueryClient();
  return (
    <BulkUpdateProgressBanner
      jobStorageKey={updateDeviceStatusJobStorageKey}
      invalidate={() => {
        queryClient.invalidateQueries({
          queryKey: [ESTIMATION_METHODS_QUERY_KEY],
        });
      }}
      subject={{
        singular: "asset",
        plural: "assets",
      }}
      action={(job) =>
        job?.input.status === AssetStatus.INACTIVE ? "inactivate" : "activate"
      }
    />
  );
};
